import { Component, Input } from '@angular/core';

interface IDevice {
  os: string;
  version: string;
  time: string;
  status: string;
}

interface IConfig {
  title: string;
  width: string;
}

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.css']
})
export class DeviceListComponent {
  @Input() list: IDevice[] = [];
  @Input() title: string = '';
  @Input() config: IConfig[] = [];
  @Input() count: number = 0;
} 